import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

// REDUX
import { useAppSelector } from '@Managers/Redux/Hooks';

import { UsePopClientGame2World } from './UsePopClient.g2w';
import { UsePopClientWorld2Game } from './UsePopClient.w2g';

import { EConfigurationNames } from '@ConfigLoader/ConfigFiles';
import ConfigLoader from '@ConfigLoader/ConfigLoader';
import { setPopClient } from '@Managers/Redux/AppState/AppState';
import { getConfigurationDataLoadedState } from '@Managers/Redux/HttpState';
import { EPopClientMessageType } from './UsePopClient.types';

export const UsePopClient = (): { g2wMessage: typeof g2wMessage } => {
    const dispatch = useDispatch();

    const { g2wMessage } = UsePopClientGame2World();
    const { w2gInit } = UsePopClientWorld2Game();
    const configurationDataLoaded = useAppSelector(getConfigurationDataLoadedState);

    const init = () => {
        const handshake = {
            _type: EPopClientMessageType.BASIC_G2W_INITIALIZATION_REQUEST,
            version: ConfigLoader.getConfiguration(EConfigurationNames.UI_LAYER).popClient?.version,
            features: [] as string[]
        };
        const features = ConfigLoader.getConfiguration(EConfigurationNames.UI_LAYER).popClient?.features;

        for (let key in features) {
            if (features[key]) handshake.features.push(key);
        }

        w2gInit();
        g2wMessage(handshake, false);
    };

    useEffect(() => {}, []);

    useEffect(() => {
        if (configurationDataLoaded) {
            if (ConfigLoader.getConfiguration(EConfigurationNames.UI_LAYER).popClient?.mode) {
                init();
            } else {
                dispatch(setPopClient({ enabled: false }));
            }
        }
    }, [configurationDataLoaded]);

    return {
        g2wMessage
    };
};
